import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { trackByProp } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconComponent,
} from '@core/user-interface-legacy';

type HeadingOption = {
  level: number;
  icon: IconName;
  label: string;
  isSelected: boolean;
};

@Component({
  selector: 'rt-heading-menu',
  imports: [CommonModule, DropdownComponent, DropdownItemComponent, TranslatePipe, IconComponent],
  templateUrl: './heading-menu.component.html',
  styleUrl: './heading-menu.component.less',
})
export class HeadingMenuComponent {
  public readonly trackByLevel = trackByProp<{ level: number }>({ prop: 'level' });
  public readonly DropdownWidth = DropdownWidth;

  public select: (val: { level: number }) => void;
  public close: () => void;
  public initialLevel: number = 0;

  public options: HeadingOption[] = [];

  public ngOnInit() {
    this.options = this.getOptions();
  }

  private getOptions() {
    return <HeadingOption[]>[
      {
        level: 0,
        icon: 'match-case',
        label: 'wysiwyg.text',
        isSelected: this.initialLevel === 0,
      },
      ...[1, 2, 3, 4].map(level => ({
        level,
        icon: `format-h${level}`,
        label: `wysiwyg.heading${level}`,
        isSelected: this.initialLevel === level,
      })),
    ];
  }
}
